import React from "react";
import Navbar from "../../components/Home/Navbar/Navbar";
import BookList from "../../components/Home/BookList/BookList";

const Home = () => {
  return (
    <div>
      <Navbar />
      <BookList />
    </div>
  );
};

export default Home;
